import { LocaleId, TranslationDictionaryMapping } from '@i18n';
import { FeatureOrderConfirmationTranslationDictionary } from './feature-order-confirmation-dictionary.interface';

export const translation: TranslationDictionaryMapping<FeatureOrderConfirmationTranslationDictionary> =
  {
    [LocaleId.English_GreatBritain]: {
      ORDER_CONFIRMATION_PAGE_TITLE: "That's it, you're all set!",
      ORDER_CONFIRMATION_PAGE_SUBTITLE:
        "Registration and protection confirmed. We'll send you a confirmation email shortly.",
      ORDER_CONFIRMATION_PROTECTED_APPLIANCE_SUMMARY_TITLE:
        'Congratulations! Here are your protection details',
      ORDER_CONFIRMATION_PROTECTED_APPLIANCE_SUMMARY_APPLIANCE_TYPE_LABEL:
        'Appliance Type',
      ORDER_CONFIRMATION_PROTECTED_APPLIANCE_SUMMARY_POLICY_NUMBER_LABEL:
        'Policy number',
      ORDER_CONFIRMATION_PROTECTED_APPLIANCE_SUMMARY_POLICY_START_DATE_LABEL:
        'Plan start date',
      ORDER_CONFIRMATION_PROTECTED_APPLIANCE_SUMMARY_FIRST_X_PAYMENTS_LABEL:
        'First {{ numberOfDiscountedMonths }} payments',
      ORDER_CONFIRMATION_PROTECTED_APPLIANCE_SUMMARY_SUBSEQUENT_PAYMENT_LABEL:
        'Subsequent payment',
      ORDER_CONFIRMATION_PROTECTED_APPLIANCE_SUMMARY_PURCHASE_DATE_LABEL:
        'Purchase date',
    },
    [LocaleId.English_Ireland]: {
      ORDER_CONFIRMATION_PAGE_TITLE: "That's it, you're all set!",
      ORDER_CONFIRMATION_PAGE_SUBTITLE:
        "Registration and protection confirmed. We'll send you a confirmation email shortly.",
      ORDER_CONFIRMATION_PROTECTED_APPLIANCE_SUMMARY_TITLE:
        'Congratulations! Here are your protection details',
      ORDER_CONFIRMATION_PROTECTED_APPLIANCE_SUMMARY_APPLIANCE_TYPE_LABEL:
        'Appliance Type',
      ORDER_CONFIRMATION_PROTECTED_APPLIANCE_SUMMARY_POLICY_NUMBER_LABEL:
        'Policy number',
      ORDER_CONFIRMATION_PROTECTED_APPLIANCE_SUMMARY_POLICY_START_DATE_LABEL:
        'Plan start date',
      ORDER_CONFIRMATION_PROTECTED_APPLIANCE_SUMMARY_FIRST_X_PAYMENTS_LABEL:
        'First {{ numberOfDiscountedMonths }} payments',
      ORDER_CONFIRMATION_PROTECTED_APPLIANCE_SUMMARY_SUBSEQUENT_PAYMENT_LABEL:
        'Subsequent payment',
      ORDER_CONFIRMATION_PROTECTED_APPLIANCE_SUMMARY_PURCHASE_DATE_LABEL:
        'Purchase date',
    },
  };
